import React, { useEffect, useState } from 'react';
import Cookies2 from 'universal-cookie';

const cookiesOptions = [
  {
    id: 0,
    text: "Only essential cookies",
    values: []
  },
  {
    id: 1,
    text: "Essential and functionality cookies",
    values: ["functionality_cookies"]
  },
  {
    id: 2,
    text: "All cookies",
    values: ["functionality_cookies", "targeting_cookies"]
  }
]

const Cookies = () => {
  const cookies = new Cookies2();
  const [selected, setSelected] = useState(0); // Default to "All cookies"

  const deleteAllExcept = (exceptions = []) => {
    // Get all cookies from document.cookie and transform it into an array
    const allCookies = document.cookie.split(';').map(cookie => cookie.split('=')[0].trim());

    // Loop through all cookies and delete the ones not in exceptions list
    for (let cookieName of allCookies) {
      if (!exceptions.includes(cookieName)) {
        cookies.remove(cookieName);
        console.log(cookieName)
      }
    }
  };

  useEffect(() => {
    cookies.set('acknowledged_cookies', true, { path: '/', expires: new Date(Date.now() + 365 * 86400 * 1000) });
    if (cookies.get("functionality_cookies")?.toString() === 'true' && cookies.get("targeting_cookies")?.toString() === 'true') {
      setSelected(2);
    }
    else if (cookies.get("functionality_cookies")?.toString() === 'true' ) {
      setSelected(1)
      deleteAllExcept(['token', 'subuser', 'acknowledged_cookies', 'functionality_cookies']);
    }
    else {
      deleteAllExcept(['token', 'subuser', 'acknowledged_cookies']);
    }
  }, [])

  const handleRadioChange = (id) => {
    setSelected(id);
    if (id == 0) {
      deleteAllExcept(['token', 'subuser', 'acknowledged_cookies']);
    }
    else if (id == 1) {
      deleteAllExcept(['token', 'subuser', 'acknowledged_cookies']);
      cookies.set('functionality_cookies', true, { path: '/', expires: new Date(Date.now() + 365 * 86400 * 1000) });
    }
    else {
      cookies.set('functionality_cookies', true, { path: '/', expires: new Date(Date.now() + 365 * 86400 * 1000) });
      cookies.set('targeting_cookies', true, { path: '/', expires: new Date(Date.now() + 365 * 86400 * 1000) });
    }
    window.location.reload();
  };


  return (
    <>
      <div className='cookie-policy-container'>
        <h2>Change preferences</h2>
        {cookiesOptions.map(option => (
          <div key={option.id}>
            <input
              type="radio"
              id={`cookie-option-${option.id}`}
              name="cookieOptions"
              value={option.id}
              checked={selected === option.id}
              onChange={() => handleRadioChange(option.id)}
            />
            <label htmlFor={`cookie-option-${option.id}`}>{option.text}</label>
          </div>
        ))}
      </div>
      <div className='cookie-policy-container'>
        <h2>Cookie Policy</h2>
        <p>We use cookies to help improve your experience of our website at <a href="https://blububl.com">https://blububl.com</a>. This cookie policy is part of TextLink&#39;s privacy policy. It covers the use of cookies between your device and our site. </p>
        <p>We also provide basic information on third-party services we may use, who may also use cookies as part of their service. This policy does not cover their cookies. </p>
        <p>If you don't wish to accept cookies from us, you should instruct your browser to refuse cookies from <a href="https://blububl.com">https://blububl.com</a>. In such a case, we may be unable to provide you with some of your desired content and services. </p>
        <h3>What is a cookie?</h3>
        <p>A cookie is a small piece of data that a website stores on your device when you visit. It typically contains information about the website itself, a unique identifier that allows the site to recognize your web browser when you return, additional data that serves the cookie's purpose, and the lifespan of the cookie itself. </p>
        <p>Cookies are used to enable certain features (e.g. logging in), track site usage (e.g. analytics), store your user settings (e.g. time zone, notification preferences), and to personalize your content (e.g. advertising, language). </p>
        <p>Cookies set by the website you are visiting are usually referred to as first-party cookies. They typically only track your activity on that particular site. </p>
        <p>Cookies set by other sites and companies (i.e. third parties) are called third-party cookies They can be used to track you on other websites that use the same third-party service. </p>
        <h3>Types of cookies and how we use them</h3>
        <h4>Essential cookies</h4>
        <p>Essential cookies are crucial to your experience of a website, enabling core features like user logins, account management, shopping carts, and payment processing. </p>
        <p>We use essential cookies to enable certain functions on our website. </p>
        <h4>Performance cookies</h4>
        <p>Performance cookies track how you use a website during your visit. Typically, this information is anonymous and aggregated, with information tracked across all site users. They help companies understand visitor usage patterns, identify and diagnose problems or errors their users may encounter, and make better strategic decisions in improving their audience's overall website experience. These cookies may be set by the website you're visiting (first-party) or by third-party services. They do not collect personal information about you. </p>
        <p>We use performance cookies on our site. </p>
        <h4>Functionality cookies</h4>
        <p>Functionality cookies are used to collect information about your device and any settings you may configure on the website you're visiting (like language and time zone settings). With this information, websites can provide you with customized, enhanced, or optimized content and services. These cookies may be set by the website you're visiting (first-party) or by third-party services. </p>
        <p>We use functionality cookies for selected features on our site. </p>
        <h4>Targeting/advertising cookies</h4>
        <p>Targeting/advertising cookies help determine what promotional content is most relevant and appropriate to you and your interests. Websites may use them to deliver targeted advertising or limit the number of times you see an advertisement. This helps companies improve the effectiveness of their campaigns and the quality of content presented to you. These cookies may be set by the website you're visiting (first-party) or by third-party services. Targeting/advertising cookies set by third-parties may be used to track you on other websites that use the same third-party service. </p>
        <p>We use targeting/advertising cookies on our site. </p>
      </div>
      <div style={{ height: "10vh" }}></div>
    </>
  );
};

export default Cookies;
